import React, { useEffect, useState } from "react";
import { FaFrownOpen } from "react-icons/fa";
import { Helmet } from "react-helmet";


const Gallery = () => {
 let [data,setData]=useState([])

  const [selectedGallery, setSelectedGallery] = useState(null);
  const [zoomedImage, setZoomedImage] = useState(null);

  const handleOpenModal = (gallery) => {
    setSelectedGallery(gallery);
  };

  const handleCloseModal = () => {
    setSelectedGallery(null);
    setZoomedImage(null);
  };


async function getApiData() {
  try {
    let response = await fetch("http://34.228.14.188:8000/api/gallery", {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    });

    response = await response.json();

    if (response.result === "Done") {
      setData(response.data);
    } else {
    }
  } catch (error) {
    console.error("API Error:", error); 
  }
}


useEffect(() => {
  getApiData();
}, []);

useEffect(() => {
}, [data]);



  return (
    <>

{/* SEO Tags */}
      <Helmet>
        <title>Gallery - V Hotel The Grand Shoba</title>
        <meta
          name="description"
          content="Explore our collection of stunning photos showcasing our rooms, banquet facilities, and dining experiences."
        />
        <meta name="keywords" content="hotel gallery, rooms gallery, banquet, restaurant, hotel photos" />
        <meta property="og:title" content="Gallery - Your Hotel Name" />
        <meta
          property="og:description"
          content="Explore our collection of stunning photos showcasing our rooms, banquet facilities, and dining experiences."
        />
        <meta property="og:image" content="URL-to-an-image.jpg" />
        <meta property="og:url" content="https://your-website.com/gallery" />
        <meta name="twitter:title" content="Gallery - Your Hotel Name" />
        <meta
          name="twitter:description"
          content="Explore our collection of stunning photos showcasing our rooms, banquet facilities, and dining experiences."
        />
        <meta name="twitter:image" content="URL-to-an-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="gallery-h2">
        <h1 className="text-center mb-4">Our Gallery</h1>
      </div>

      {
        data.length?

        <div className="container py-5">
        <div className="row g-4">
          {data.map((item, idx) => (
            <div className="col-12 col-sm-6 col-lg-4" key={idx}>
              <div
                className="card gallery-card border-0 shadow-sm h-100"
                onClick={() => handleOpenModal(item.pic)}
                style={{ cursor: "pointer" }}
              >
                <div className="overflow-hidden m-auto gallery-img-div">
                  <img
                    src={`http://34.228.14.188:8000${item.pic[0]}`}
                    title="V Hotel The Grnad Shoba Gallery"
                    loading="lazy"
                    alt={`V Hotel The Grnad Shoba ${item.name}`}
                    className="card-img-top  gallery-img"
                  />
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title">{item.name}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      :
     <div className="not-testinomonil mt-3 mb-3">
                    <h3 style={{color:"#856a2b"}}>Sorry! <FaFrownOpen /> Images Record Not Found!!</h3>
                    
                  </div>
      }

      {selectedGallery && (
        <div className="custom-modal-backdrop" onClick={handleCloseModal}>
          <div
            className="custom-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleCloseModal}>
              ×
            </button>

            <div className=" mx-5 gap-2 justify-content-center">
              {selectedGallery.map((img, i) => (
                <img
                  key={i}
                  src={`http://34.228.14.188:8000${img}`}
                  alt={`img-${i}`}
                  className="modal-thumb mx-2 my-2"
                  onClick={() => setZoomedImage(img)}
                />
              ))}
            </div>

            {zoomedImage && (
              <div className="zoomed-image-container" onClick={() => setZoomedImage(null)}>
                <img src={`http://34.228.14.188:8000${zoomedImage}`} loading="lazy" alt="Zoomed-images" className="zoomed-image" />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
